import { type FC } from "react";

import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../core/components";

export const StatusIndicator = styled.div<{ background: string }>`
    width: 8px;
    height: 8px;
    margin-right: 4px;

    background: ${({ background }) => background};
    border-radius: 8px;
`;

export interface StatusCellProps {
    status: string;
    statusMap: Record<string, { text: string; color?: string }>;
}

const unknownStatusLabel = { text: "_", color: Colors.Gray.V250 };

export const StatusCell: FC<StatusCellProps> = ({ status, statusMap }) => {
    const { text, color } = statusMap[status] ?? unknownStatusLabel;

    return (
        <Flexbox alignItems="center">
            {color && <StatusIndicator background={color} />}
            {text}
        </Flexbox>
    );
};
